"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const _1 = require(".");
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const scale_1 = require("../../../utils/scale");
const ArticleItem_1 = __importDefault(require("./ArticleItem"));
const TabArticles = (props) => {
    const { isActive, userId, userNickname, isMyProfile } = props;
    const [articles, setArticles] = (0, react_1.useState)([]);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [isLoadMore, setLoadMore] = (0, react_1.useState)(false);
    const refNoMoreData = (0, react_1.useRef)(false);
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const refIsActive = (0, react_1.useRef)(isActive);
    const refIsInitData = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (isLoadMore && isActive && !refNoMoreData.current) {
            handleGetArticles();
        }
    }, [isLoadMore]);
    (0, react_1.useEffect)(() => {
        if (isActive && articles.length == 0 && !refNoMoreData.current) {
            handleGetArticles();
        }
        refIsActive.current = isActive;
    }, [isActive]);
    (0, react_1.useEffect)(() => {
        const listener = new react_native_1.NativeEventEmitter().addListener(constants_1.listenerEvents.PROFILE_REACHED_END, () => {
            if (!refNoMoreData.current && refIsActive.current && refIsInitData.current) {
                setLoadMore(true);
            }
        });
        return () => listener.remove();
    }, []);
    const displayTweet = (data) => {
        let list = [...articles];
        list = list.filter((item) => item?.article_id != data);
        setArticles(list);
    };
    const handleGetArticles = () => {
        if (currentPage == 1) {
            setLoading(true);
        }
        ;
        (isMyProfile
            ? User_1.default.getUserRetrievalArticles(1, currentPage)
            : User_1.default.getUserDetailArticles(userId, 1, currentPage))
            .then((response) => {
            if (response.data.current_page == response.data.last_page) {
                refNoMoreData.current = true;
            }
            if (response.data.data.length > 0) {
                setArticles([...articles, ...response.data.data]);
                setCurrentPage(response.data.current_page + 1);
            }
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            setLoading(false);
            setLoadMore(false);
            refIsInitData.current = true;
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles.container, !isActive && { display: 'none' }] },
        isLoading ? (react_1.default.createElement(components_1.LoadingView, { style: { backgroundColor: '#F7F7F7' } })) : articles?.length == 0 ? (react_1.default.createElement(react_native_1.View, { style: {
                marginTop: (0, scale_1.scale)(32),
                width: '100%',
                justifyContent: 'center',
                paddingHorizontal: (0, scale_1.scale)(15),
                paddingBottom: inset.bottom + (0, scale_1.scale)(30)
            } },
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(16),
                    lineHeight: (0, scale_1.moderateScale)(24),
                    textAlign: 'center',
                    color: '#292A33',
                } }, !isMyProfile
                ? `まだ記事に対する履歴がありません。`
                : `このページでは、あなたの記事に対する活動履歴を確認できます。`))) : (articles.map((item, index) => {
            let data = item;
            data.content_type = 1;
            return (react_1.default.createElement(ArticleItem_1.default, { data: data, key: index, userId: userId, tagVisible: isMyProfile, displayTweet: (data) => {
                    displayTweet(data);
                }, userNickname: userNickname, isMyProfile: isMyProfile }));
        })),
        isLoadMore && react_1.default.createElement(_1.TabBarLoading, null)));
};
exports.default = TabArticles;
const styles = react_native_1.StyleSheet.create({
    container: {},
});
